// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TraWhtpService {

  apiUrl: string;

  companiesSelected: any[];
  companiesSelectedChange: Subject<any[]> = new Subject<any[]>();

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;

    this.companiesSelectedChange.subscribe((companies) => {
      this.companiesSelected = companies;
    });
  }

  changeCompaniesSelected(companies: any[]): void {
    this.companiesSelectedChange.next(companies);
  }

  getSummary(
    companies: string[],
    years: string[]
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let companyStr = '';
    let yearStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/summary?${companyStr}&${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getConceptDetailsType1(
    conceptId: string,
    companies: string[],
    years: string[] = []
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let companyStr = '';
    let yearStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/conceptDetailsType1/${conceptId}?${companyStr}&${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getConceptDetailsType2(
    conceptId: string,
    companies: string[],
    years: string[] = []
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let companyStr = '';
    let yearStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/conceptDetailsType2/${conceptId}?${companyStr}&${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getConceptDetailsType3(
    conceptId: string,
    companies: string[],
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let companyStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/conceptDetailsSeverancePayments/${conceptId}?${companyStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getConceptDetailsSeverancePayments(
    conceptId: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/conceptDetailsSeverancePayments/${conceptId}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getConceptDetailsSeverancePaymentsPerRecipient(
    conceptId: string = '',
    recipientId: string = '',
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `tra/whtp/analysis/conceptDetailsSeverancePayments/${conceptId}/recipient/${recipientId}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getAnnualReconcilations(
    companies: any[] = [],
    years: any[] = [],
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    let companyStr = '';
    let yearStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/reconciliations/annualReconciliation?${companyStr}&${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getAnnualReconcilationsPerComp(
    companyId: string,
    years: any[] = [],
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    let yearStr = '';
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/reconciliations/annualReconciliationPerCompany/${companyId}?${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getAccountingReconcilations(
    companies: any[] = [],
    years: any[] = [],
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    let companyStr = '';
    let yearStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/reconciliations/accountingReconciliation?${companyStr}&${yearStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getAccountingReconcilationsPerAccount(
    companyId: string,
    years: any[] = [],
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    let yearStr = '';
    if (Array.isArray(years) && years.length > 0) {
      years.some((year, i) => {
        yearStr = yearStr.concat('years=' + year);
        yearStr = i + 1 < years.length ? yearStr.concat('&') : yearStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/reconciliations/accountingReconciliationPerCompany/${companyId}?${yearStr}`;
    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

  getTestSummary(
    companies: any[] = []
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    let companyStr = '';
    if (Array.isArray(companies) && companies.length > 0) {
      companies.some((comp, i) => {
        companyStr = companyStr.concat('companyIds=' + comp);
        companyStr = i + 1 < companies.length ? companyStr.concat('&') : companyStr;
      });
    }
    const requesttUrl = this.apiUrl + `tra/whtp/payrollTest/whtpTestSummary?${companyStr}`;

    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }


  getTestSummaryPerYear(
    companyId,
    year
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `tra/whtp/payrollTest/whtpTestSummaryPerYear/${companyId}?years=${year}`;
    return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => res),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
              })
        );
  }

}
